import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import principle02 from "./layouts/principle-02/principle";
import task01 from "./layouts/task-01/task";
import task02 from "./layouts/task-02/task";
import task03 from "./layouts/task-03/task";

const lesson: Lesson = {
  id: "7104d555-6856-483a-9815-af7a75be3ead",
  publicId: "13",
  name: "Head Related Transfer Function",
  difficulty: 2,
  contentTypes: { audio: false, interactive: true, video: false },
  body: [principle01, principle02, task01, task02, task03],
};

export default lesson;
